(function () {
    if (window.footerColumnToggleLoaded) return;
    window.footerColumnToggleLoaded = true;

    var MOBILE_BREAKPOINT = 767;

    function isMobile() {
        return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    document.addEventListener('click', function (e) {
        var heading = e.target.closest('[data-toggle-column-footer]');
        if (!heading) return;
        if (!isMobile()) return;
        e.preventDefault();
        var willOpen = !heading.classList.contains('is-clicked');
        var others = document.querySelectorAll('[data-toggle-column-footer].is-clicked');
        for (var i = 0; i < others.length; i++) {
            if (others[i] !== heading) others[i].classList.remove('is-clicked');
        }
        heading.classList.toggle('is-clicked', willOpen);
    });

    window.addEventListener('resize', function () {
        if (isMobile()) return;
        var opened = document.querySelectorAll('[data-toggle-column-footer].is-clicked');
        for (var i = 0; i < opened.length; i++) {
            opened[i].classList.remove('is-clicked');
        }
    });
})();
